export enum SkatIntegrationStatus {
  Connecting = 'connecting',
  Idle = 'idle',
  Redirecting = 'redirecting',
}
